import dayjs from "dayjs";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import NO_IMAGE_AVAILABLE from "@assets/images/NO_IMAGE_AVAILABLE.jpg";
import { Button } from "@components/Button";
import { Text } from "@components/Text";
import { COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";

const { REACT_APP_API_ENDPOINT } = process.env;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ContainerContent = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: center;
  align-items: center;
`;

const ContainerImage = styled.div`
  height: 40px;
  aspect-ratio: 16/9;
`;

const SectionAction = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;

export const ImportImage = ({
  item,
  campaignData,
  onHandleImportBlockMedias = () => undefined,
}) => {
  const path = `${REACT_APP_API_ENDPOINT}/${_.get(item, ["path"])}`;

  const onHandleImport = () => {
    const blockMedia = {
      type: "image",
      is_use_media_in_project: true,
      media_id: _.get(item, ["id"]),
      duration: _.get(item, ["duration"]),
      repeat: _.get(item, ["repeat"], 1),
      start_date: dayjs(campaignData?.campaign_start_date).format("YYYY-MM-DD"),
      end_date: dayjs(campaignData?.campaign_end_date).format("YYYY-MM-DD"),
      attribute: { objectFit: "fill", path: _.get(item, ["path"]) },
    };
    onHandleImportBlockMedias({ item: blockMedia });
  };
  return (
    <Container>
      <ContainerContent>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <ContainerImage>
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              src={path}
              alt={"get-led"}
              onError={({ target }) => {
                target.onerror = null;
                target.src = NO_IMAGE_AVAILABLE;
                target.style.objectFit = "cover";
              }}
            />
          </ContainerImage>
          <div style={{ width: "calc(100% - 85px)" }}>
            <Text isEllipsis={true} lines={1}>
              {_.get(item, ["display_name"])}
            </Text>
          </div>
        </div>

        <SectionAction>
          <Button
            type="button"
            color={COLOR_GREEN}
            padding="2px 12px"
            onClick={() => onHandleImport()}
          >
            <Text fontSize={"12px"} fontWeight="600" color={COLOR_WHITE}>
              ADD
            </Text>
          </Button>
        </SectionAction>
      </ContainerContent>
    </Container>
  );
};
